import { useTranslation } from "react-i18next";
import type { TOptions } from "i18next";

import config from "@/constants/config";

import type {
  FilterNamespaceKeys,
  UseSalesPointTranslationKeyResults,
  ValidNamespaceKeys,
} from "./useSalesPointTranslationKey.types";

const useSalesPointTranslationKey = (): UseSalesPointTranslationKeyResults => {
  const { i18n, t } = useTranslation();

  const isKeyValid = (key: string) =>
    i18n.exists(key, { ns: "salespoint" }) && t(key, "", { ns: "salespoint" });

  const resolveKey = <
    TKey extends ValidNamespaceKeys<TOpt>,
    TOpt extends TOptions,
  >(
    key: TKey,
    _tOptions?: TOpt,
  ): FilterNamespaceKeys<TKey, TOpt>[] => {
    if (
      isKeyValid(
        `${config.tenantConfig.key}.${config.tenantConfig.location}.${String(key)}`,
      )
    ) {
      return [
        `${config.tenantConfig.key}.${config.tenantConfig.location}.${String(key)}`,
      ] as FilterNamespaceKeys<TKey, TOpt>[];
    }

    if (isKeyValid(`${config.tenantConfig.key}.default.${String(key)}`)) {
      return [
        `${config.tenantConfig.key}.default.${String(key)}`,
      ] as FilterNamespaceKeys<TKey, TOpt>[];
    }

    if (isKeyValid(`default.${String(key)}`)) {
      return [`default.${String(key)}`] as FilterNamespaceKeys<TKey, TOpt>[];
    }

    return [
      `${config.tenantConfig.key}.${config.tenantConfig.location}.${String(key)}`,
    ] as FilterNamespaceKeys<TKey, TOpt>[];
  };

  return {
    resolveKey,
  };
};

export default useSalesPointTranslationKey;
